import "./ccSchools.css";

/* Same five marks as the home page hero, in the same order Jacob asked for
   there on 2026-09-10: Penn, Hamilton, Denver, Jefferson, Lander. Not
   alphabetical — leave as is, and change both places together if it changes.
   These are the assets/Schools/trimmed copies, cropped to the ink, not the
   originals: the untrimmed files carry wildly different amounts of empty
   space baked around the mark, so one CSS height rule renders them at
   completely different sizes. Trim any new logo the same way before adding
   it rather than scaling it in code. */
import logoPenn from "../../../assets/Schools/trimmed/University of Pennsylvania.webp";
import logoHamilton from "../../../assets/Schools/trimmed/Hamilton College.webp";
import logoDenver from "../../../assets/Schools/trimmed/University of Denver.webp";
import logoJefferson from "../../../assets/Schools/trimmed/Jefferson Community College.webp";
import logoLander from "../../../assets/Schools/trimmed/Lander University.webp";

/* `h` is each mark's height as a multiple of the row's base height rather
   than a pixel value, so the row scales as one at smaller breakpoints. The
   values are matched on ink mass, not bounding box: a dense wide lockup like
   Denver carries far more weight at a given height than a sparse stacked one
   like Jefferson, so sizing them all the same looks wrong. Carried over from
   the home page hero so the two rows render the marks identically. */
const schools = [
  { name: "University of Pennsylvania", src: logoPenn, h: 1 },
  { name: "Hamilton College", src: logoHamilton, h: 1.67 },
  { name: "University of Denver", src: logoDenver, h: 0.81 },
  { name: "Jefferson Community College", src: logoJefferson, h: 1.71 },
  { name: "Lander University", src: logoLander, h: 1.05 },
];

const CcSchools = () => (
  <section className="cc-schools-band">
    <div className="home-container cc-schools-grid">
      <h2 className="cc-schools-title">
        60+ career
        <br />
        centers
      </h2>

      <ul className="cc-schools-row">
        {schools.map(({ name, src, h }) => (
          <li key={name}>
            <img decoding="async" src={src} alt={name} style={{ "--h": h }} loading="lazy" />
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default CcSchools;
